import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ZzzConfigService as ConfigService } from 'src/app/zzz/core/config/config.service';
import { ReponseValeurDomaine } from "../models/domaines.dto";

@Injectable({
  providedIn: "root"
})
export class DomainesService {
  #backend = inject(HttpBackend);
  #http = new HttpClient(this.#backend);

  private urlApi: string;

  constructor(
    private configService: ConfigService
  ) {
    this.urlApi = this.configService.get().authApiEndPoint;
  }

  obtenirValeurs(domCode: string): Observable<ReponseValeurDomaine> {
    const url = `${this.urlApi}/sigtapi/domaines/${domCode}/valeur`;
    return this.#http.get<ReponseValeurDomaine>(url);
  }
}
